import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Tooltip, Whisper } from 'rsuite';
import { BaseCell } from '../../../../../../../components';
import { RuleDataItem, RuleSegment } from '../../lib/service';
import { listFormater, parseSensibilityType } from '../../lib/utils';
import styles from './RulePageTableRuleCell.module.scss';

const RulePageTableRuleCell = ({
  name = '--',
  segments = [],
  sensibilityType = '',
  infoPriceSensibility,
  infoPriceAbcClass,
  infoPriceGlobalAbcClass,
  abcClass,
}: RuleDataItem) => {
  const segmentsString = useMemo(() => {
    const mapSegment = ({ description, value }: RuleSegment): string => {
      if (!value) return '';
      if (description?.length) return `${value} - ${description}`;
      return value;
    };
    return listFormater.format(segments?.map(mapSegment) ?? '');
  }, [segments]);

  const infoPriceSensibilityString = useMemo(() => {
    return parseSensibilityType({
      sensibilityType,
      infoPriceSensibility,
      infoPriceAbcClass,
      infoPriceGlobalAbcClass,
      abcClass,
    });
  }, [abcClass, infoPriceAbcClass, infoPriceGlobalAbcClass, infoPriceSensibility, sensibilityType]);

  return (
    <BaseCell className={styles.wrapper}>
      <BaseCell.MainContainer>{name}</BaseCell.MainContainer>
      <Whisper speaker={<Tooltip>{segmentsString}</Tooltip>}>
        <p className={classNames(styles.segments, 'truncate')}>{segmentsString}</p>
      </Whisper>
      <div className={styles.badge}>{infoPriceSensibilityString}</div>
    </BaseCell>
  );
};

export default RulePageTableRuleCell;
